import masonryStyles from "../Masonry/skeleton.module.less";

/**
 * 单个Pin卡片的骨架屏组件
 * 使用原来的骨架屏样式
 */
export default function PinCardSkeleton({ style, pin_id }) {
  // 使用固定的高度模式，避免任何变化
  const heights = [242, 278, 329]; // 简化为3种高度

  // 基于pin_id的最后一个字符来确定高度（更简单稳定的方式）
  const getStableHeight = (id) => {
    if (!id) return heights[0]; // 默认高度
    const lastChar = id.slice(-1);
    const index = lastChar.charCodeAt(0) % heights.length;
    return heights[index];
  };

  const stableHeight = getStableHeight(pin_id);

  return (
    <div className={masonryStyles.skeletonItem} style={style}>
      <div
        className={masonryStyles.imageplaceholder}
        style={{ height: style?.height || stableHeight }}
      />
      <div className={masonryStyles.textplaceholder} />
    </div>
  );
}
